export enum QuoteDetailMode {
  ForCustomer = 'customer',
  ForProspect = 'prospect',
}